import makeRequest from '../common/helpers/makeRequest';

const loadSettings = async (settingsType: string) => {
  return await makeRequest<{ settings: string } | null>(`/settings/${settingsType}`, 'GET');
};

const updateSettings = async (settingsType: string, value: string) => {
  return await makeRequest<boolean>(`/settings/${settingsType}`, 'POST', value);
};

const api = {
  loadSettings,
  updateSettings,
};

export default api;
